import { render, staticRenderFns } from "./ProjectItems.vue?vue&type=template&id=e1c8970c&"
import script from "./ProjectItems.vue?vue&type=script&lang=js&"
export * from "./ProjectItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports